import { validateInputAlphanumeric } from '../../../../../../validation/validation';

// --- Interfaces ---

/**
 * Shape of the data to be validated
 */
export interface AgentValidationFields {
    commission?: string | number | null;
    pbNumber?: string | null;
    vstNumber?: string;
    generalAgency?: string | number | null;
    agentInfo?: any;
    isZic?: boolean;
}

/**
 * Shape of the error object returned by the validate function
 * Each key corresponds to a field and contains a translation string or undefined
 */
export type AgentValidationErrors = {
    [K in keyof Omit<AgentValidationFields, 'isZic' | 'agentInfo'>]: string | undefined;
} & {
    agent?: string | undefined;
};

type TFunction = (key: string) => string;

// --- Functions ---

export const validate = (
    {
        commission,
        pbNumber,
        vstNumber,
        generalAgency,
        agentInfo,
        isZic,
    }: AgentValidationFields,
    t: TFunction,
): AgentValidationErrors => ({
    commission: (() => {
        if (isZic || isZic == null) {
            return undefined;
        }
        if (commission === undefined || commission === null || commission === '') {
            return t('validation.mandatoryField');
        }

        return undefined;
    })(),
    pbNumber: (() => {
        if (!pbNumber) {
            return t('validation.mandatoryField');
        }
        if (pbNumber.length > 9) {
            return t('validation.fieldLength');
        }

        return undefined;
    })(),
    vstNumber: (() => validateInputAlphanumeric(vstNumber || '', true) as string)(),
    generalAgency: (() => {
        if (!generalAgency) {
            return t('validation.mandatoryField');
        }

        return undefined;
    })(),
    agent: (() => {
        if (!agentInfo) {
            return t('validation.mandatoryField');
        }

        return undefined;
    })(),
});

/**
 * Checks if the validation object is clean (no error messages present)
 */
export const isValid = (validation: AgentValidationErrors): boolean => !Object.keys(validation).find((key) => validation[key as keyof AgentValidationErrors]);
